import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';
import { Avatar } from '@mui/material';
import Person3Icon from '@mui/icons-material/Person3';
import Logout from '@mui/icons-material/Logout';
import ListItemIcon from '@mui/material/ListItemIcon';
import { useContext, useState } from 'react';
import { grey } from '@mui/material/colors';
import { AuthContext } from '../../Context/AuthContext';
import { useNavigate } from 'react-router-dom';


export default function AvatarUser() {
    const [anchorEl, setAnchorEl] =useState(null);
    const navigate = useNavigate();
    
    const open = Boolean(anchorEl);

    const { updateIsLogin } = useContext(AuthContext);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogount = () => {
        updateIsLogin(false);
        navigate('/');
    }

    return (
        <div>
            <Avatar onClick={handleClick} sx={{ mr: 2, bgcolor: grey[300]}}><Person3Icon /></Avatar>

            <Menu
                id="fade-menu"
                MenuListProps={{
                    'aria-labelledby': 'fade-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                TransitionComponent={Fade}
            >
                <MenuItem onClick={handleLogount}>
                    <ListItemIcon>
                        <Logout fontSize="small"  />
                    </ListItemIcon>
                    Salir
                </MenuItem>
            </Menu>
        </div>
    );
}